import React, { FC, memo, useMemo } from 'react';

import Typography from '@mui/material/Typography';

import Tooltip from '@components/common/Tooltip';

import {
  REBALANCE_STATUS_TITLE,
  RebalanceStatus,
} from '@constants/vaults/vault.constants';

import { VaultFarmsType } from '@app-types/vaults/vault.types';

import AutomaticRebalancingTooltip from './AutomaticRebalancingTooltip';
import useStyles from './styles.module';

interface Props {
  selectedV3Farm: VaultFarmsType;
}

const AutomaticRebalancing: FC<Props> = ({ selectedV3Farm }) => {
  const status: RebalanceStatus = useMemo<RebalanceStatus>(() => {
    if (selectedV3Farm.farm.isAilmEnabled) {
      return RebalanceStatus.Fixed;
    }
    return selectedV3Farm.farm.isAlmEnabled
      ? RebalanceStatus.Active
      : RebalanceStatus.Paused;
  }, [selectedV3Farm]);

  const { classes } = useStyles({ status });

  return (
    <Typography
      variant="body2"
      color={(theme) => theme.secondary.s3}
      className={classes.statusTitle}
    >
      Automatic rebalancing:{' '}
      <span className={classes.status}>{REBALANCE_STATUS_TITLE[status]}</span>
      <Tooltip title={<AutomaticRebalancingTooltip />} isInfo />
    </Typography>
  );
};

export default memo(AutomaticRebalancing);
